import classnames from "classnames";
import * as React from "react";
import { Link as RouterLink } from "react-router-dom";

import { PageActionButton, Text } from "../";
import { LogoOnly } from "../../";
import { ArrowLeftIcon } from "../../assets/icons";
import { useDesktopStyles } from "./useDesktopStyles";

export interface DesktopPageActionsProps {
    title?: string;
    backUrl?: string;
    statusLabel?: React.ReactNode;
    showLogo?: boolean;
    children?: React.ReactNode;
    pageActionOptions?: React.ReactNode;
    pageActions?: React.ReactNode;
    giveFeedback?: React.ReactNode;
    subtitle?: React.ReactNode;
}

export const DesktopPageActions = (props: DesktopPageActionsProps) => {
    const classes = useDesktopStyles(props);

    const {
        title,
        statusLabel,
        giveFeedback,
        showLogo = false,
        pageActionOptions,
        pageActions,
        subtitle,
    } = props;
    const backButton = classnames({
        [classes.backButton]: !!subtitle,
    });

    return (
        <>
            <div className={classes.header}>
                {showLogo ? (
                    <div className={classes.logo}>
                        <PageActionButton
                            id="logoButton"
                            title="to relode.com"
                            onClick={() =>
                                (window.location.href =
                                    "https://www.relode.com")
                            }
                        >
                            <LogoOnly />
                        </PageActionButton>
                    </div>
                ) : null}
                {props.backUrl ? (
                    <RouterLink to={props.backUrl}>
                        <PageActionButton
                            data-cy="backButton"
                            id="backButton"
                            title="back to previous page"
                            color="primary"
                            className={backButton}
                        >
                            <ArrowLeftIcon />
                        </PageActionButton>
                    </RouterLink>
                ) : null}
                <div className={classes.titleContainer}>
                    {/* TODO: Josh check this for all apps if H2->H1 works here */}
                    <Text dataCy="titleText" variant="h1">
                        <span title={title} className={classes.headerText}>
                            {title}
                        </span>

                        <span className={classes.statusLabel}>
                            {statusLabel}
                        </span>
                    </Text>
                    {subtitle}
                </div>
            </div>

            <div className={classes.pageActionsOptions}>
                {pageActionOptions}
            </div>
            {pageActions}
            {giveFeedback}
        </>
    );
};
